import { NgModule } from '@angular/core';
import { AccordianComponent } from './accordian.component';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AccordianComponent],
  imports: [CommonModule, AccordionModule],
  exports: [AccordianComponent],
})
export class AccordianComponentModule {}